<template>
  <div>
    <!-- {{ userList }} -->
    <el-table :data="userList" style="width: 100%" height="calc(100vh - 360px)">
      <el-table-column prop="userId" label="用户UID" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.userId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="targetUserTypeName" label="用户类型" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.targetUserTypeName || scope.row.targetUserType }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coin" label="币种" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.coin }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="数量" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.amount }}</span>
        </template>
      </el-table-column>

      <el-table-column label="赠送时间" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.createdTime | moment }}
        </template>
      </el-table-column>
      <el-table-column label="操作人UID" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.operateId }}
        </template>
      </el-table-column>
      <!-- <el-table-column  label="是否展示备注">
        <template slot-scope="scope">
          <span v-if="scope.row">{{ scope.row.type}}</span>
        </template>
      </el-table-column> -->

      <!-- <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleUpdate(scope.row)"
            v-if="scope.row.type == 0"
            >修改备注</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleUpdatePartner(scope.row, 0)"
            v-if="scope.row.rebateRate == 0 && scope.row.type == 0"
            >升级合伙人</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleRate(scope.row, 1)"
            v-if="scope.row.rebateRate != 0 && scope.row.type == 0"
            >设置返佣比例</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>
    <!-- <update-dialog :val="userinfoDetail" :updateForm="updateForm"></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <el-dialog
      title="修改备注"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card">
          <div>备注信息</div>
          <div class="content">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入备注信息"
              maxlength="50"
              show-word-limit
              v-model="textarea2"
            >
            </el-input>
          </div>
          <div class="btn">
            <el-button size="mini" type="primary" @click="add"
              >添 加</el-button
            >
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <!-- 升级合伙人 -->
    <el-dialog
      :title="title"
      :visible.sync="partnerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card box-card1">
          <div class="content">
            <el-form label-width="50px">
              <el-form-item label="合约返佣比例 :">
                <el-input
                  type="number"
                  placeholder="请输入合约返佣比例"
                  v-model="input2"
                >
                  <template slot="append">%</template>
                </el-input>
                <div class="tip">
                  <span>
                    <i class="el-icon-warning-outline"></i>
                    说明:返佣比例一旦设定,只支持提高,不支持降低
                  </span>
                </div>
              </el-form-item>
              <el-form-item label="现货返佣比例 :">
                <el-input
                  type="number"
                  placeholder="请输入现货返佣比例"
                  v-model="spotRateInput"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="btn">
            <el-button size="mini" @click="partnerDialogVisible = false"
              >取 消</el-button
            >
            <el-button size="mini" type="primary" @click="addRate"
              >确 定</el-button
            >
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'

export default {
  name: 'giftCoinList',
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      textarea2: '',
      centerDialogVisible: false,
      partnerDialogVisible: false,
      input2: '',
      spotRateInput: '',
      upgradeRateForm: {},
      title: '',
      btnType: '',
    }
  },
  components: {
    Pagination,
    updateDialog,
  },
  methods: {
    ...mapActions('user', ['addRemark']),
    ...mapActions('giftCoin', ['upgradePartner', 'upgradeRate']),
    ...mapMutations('giftCoin', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
          ;(this.textarea2 = ''), (this.centerDialogVisible = false)
          this.$emit('refresh')
        }
      })
    },
    addRate() {
      if (this.btnType == 0) {
        this.upgradePartner({
          channelId: this.userInfo.channelId,
          userId: this.upgradeRateForm.id,
          rate: Number(this.input2),
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('申请合伙人成功')
            this.partnerDialogVisible = false
            this.input2 = ''
            this.spotRateInput = ''
            this.$emit('refresh')
          } else {
            this.$message.error(res.error.msg)
          }
        })
      }
      if (this.btnType == 1) {
        const params = {
          channelId: this.userInfo.channelId,
          userId: this.upgradeRateForm.id,
          rate: Number(this.input2),
        }
        if (
          this.spotRateInput !== '' &&
          this.spotRateInput !== null &&
          this.spotRateInput !== undefined
        ) {
          params.spotRate = Number(this.spotRateInput)
        }
        this.upgradeRate(params).then((res) => {
          if (res.code == 0) {
            this.$message.success('设置返佣比例成功')
            this.partnerDialogVisible = false
            this.input2 = ''
            this.spotRateInput = ''
          } else {
            this.$message.error(res.error.msg)
          }
        })
      }
    },
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    handleUpdate(row) {
      this.updateForm = { ...row }
      // this.setUserinfoDetail(selected);
      // this.setUserinfoDetailDialogVisible(true);

      this.centerDialogVisible = true
      this.textarea2 = row.remarks
    },
    handleUpdatePartner(row, type) {
      this.title = '升级合伙人'
      this.upgradeRateForm = { ...row }
      this.partnerDialogVisible = true
      this.btnType = type
    },
    handleRate(row, type) {
      this.title = '设置返佣比例'
      this.partnerDialogVisible = true
      this.upgradeRateForm = { ...row }
      this.input2 = row.rebateRate * 100
      this.btnType = type
      this.spotRateInput =
        row.spotRate || row.spotRate === 0 ? row.spotRate * 100 : ''
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(['userInfo']),
    ...mapState('giftCoin', [
      'pagination',
      'userList',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
    ]),
  },
}
</script>

<style lang="less" src="../../../../styles/table.less" scoped>
.pag {
  display: flex;
  justify-content: center;
}
.user-type-select {
  width: 100%;
}
.red {
  color: skyblue;
  font-weight: bold;
}
.cc {
  color: #97a0ff;
  font-weight: bold;
}
::v-deep .el-dialog__title {
  color: #6767b3;
  font-size: 24px;
}
::v-deep.el-dialog__headerbtn {
  font-size: 26px;
}
::v-deep .el-dialog__body {
  display: flex;
  justify-content: center;
  .main {
    width: 100%;
    position: relative;
    .box-card {
      width: 100%;
      height: 260px;
      .el-card__body {
        height: 86%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .el-textarea {
          box-shadow:
            0px 0px 1px rgba(24, 26, 32, 0.1),
            0px 3px 6px rgba(71, 77, 87, 0.04),
            0px 1px 2px rgba(24, 26, 32, 0.04);
        }
        .el-textarea__inner {
          padding: 18px 16px;
        }
        .btn {
          display: flex;
          justify-content: center;
          .el-button--primary {
            width: 156px;
            height: 37px;
            background: #707aff;
            border-radius: 4px;
          }
          .el-button--default {
            width: 156px;
            height: 37px;
            background-color: #f5f6f9;
          }
        }
      }
    }
    .box-card1 {
      height: 170px;
      .btn {
        padding-bottom: 10px;
      }
      .tip {
        text-align: center;
        color: #707aff;
      }
    }
  }
}
::v-deep .el-dialog--center {
  margin-top: 5vh;
  width: 468px;
  // height: 557px;
  background: #f5f6ff;
  border-radius: 8px;
}
::v-deep.el-table th {
  font-weight: bold;
  color: #909399;
}
</style>
